/* VESPR — upsell abonnement dans le tiroir de panier.

   Le thème n'emet aucun evenement de panier (verifie : ni cart:open ni
   cart:updated dans assets/*.js) et cart-drawer.js REMPLACE .cart-drawer__inner
   a chaque mise a jour. On ne peut donc ni s'accrocher a un evenement, ni
   injecter une seule fois. On observe le DOM du <cart-drawer> et on reinjecte.

   N'apparait QUE si le panier contient exactement un pot sans forfait : c'est
   la seule configuration ou l'abonnement a du sens (SUBS_OFFERS = ["single"]).
   Sur un pack de 3 ou 4, la remise Buy 2 Get 1 s'applique deja.

   Degradation : au moindre imprevu la banniere ne s'affiche pas, le panier
   reste intact. Aucun chemin ou un imprevu bloque le passage en caisse. */
(function(){
  "use strict";
  /* Clés = vraies fréquences Shopify, vérifiées le 30-08 via sellingPlanGroups. */
  var PLANS=[{w:6,id:"693311308120"},{w:8,id:"693311340888"},{w:12,id:"693311373656"}];
  var DEFAULT_W=8, chosen=DEFAULT_W;
  var SUB_PRICE="$31.92", SAVING="20%", MARK="vespr-sub-upsell";
  var observer=null, timer=null, busy=false;

  function money(c){ return "$"+(c/100).toFixed(2).replace(/\.00$/,""); }
  function anchor(){ return document.querySelector(".cart-drawer__ctas"); }
  function existing(){ return document.getElementById(MARK); }

  function planId(){
    for(var i=0;i<PLANS.length;i++){ if(PLANS[i].w===chosen) return PLANS[i].id; }
    return PLANS[1].id;
  }

  function convert(btn){
    if(busy) return; busy=true;
    btn.disabled=true; var label=btn.textContent; btn.textContent="Switching…";
    fetch("/cart/change.js",{method:"POST",
      headers:{"Content-Type":"application/json",Accept:"application/json"},
      body:JSON.stringify({line:1,selling_plan:planId()})})
      .then(function(r){ if(!r.ok) throw new Error("change"); return r.json(); })
      .then(function(){ busy=false; window.location.reload(); })
      .catch(function(){
        busy=false; btn.disabled=false; btn.textContent=label;
        alert("Could not switch to a subscription. Please try again.");
      });
  }

  function build(item){
    var box=document.createElement("div");
    box.id=MARK;
    box.setAttribute("style","margin:0 0 9px;padding:9px 11px;border:1px solid rgba(162,101,51,.35);"+
      "border-radius:10px;background:rgba(162,101,51,.06);line-height:1.3");
    var pills=PLANS.map(function(p){
      var on=p.w===chosen;
      return '<button type="button" data-vespr-w="'+p.w+'" style="flex:1;padding:5px 0;border-radius:999px;'+
        'border:1px solid rgba(162,101,51,'+(on?'.85':'.3')+');'+
        'background:'+(on?'rgba(162,101,51,.22)':'transparent')+';color:inherit;'+
        'font-weight:'+(on?'700':'500')+';font-size:.74rem;cursor:pointer">'+p.w+' wks</button>';
    }).join("");
    box.innerHTML=
      '<div style="font-weight:700;font-size:.86rem">Subscribe &mdash; '+SUB_PRICE+
        ' <span style="font-weight:400;opacity:.6;text-decoration:line-through">'+money(item.price)+'</span></div>'+
      '<div style="font-size:.73rem;opacity:.78;margin:1px 0 7px">Save '+SAVING+
        ' + free shipping on every delivery. Cancel in one click.</div>'+
      '<div data-vespr-freq style="display:flex;gap:5px;margin-bottom:7px">'+pills+'</div>'+
      '<button type="button" data-vespr-sub style="width:100%;padding:7px 12px;border-radius:999px;'+
        'border:1px solid rgba(162,101,51,.6);background:transparent;color:inherit;font-weight:600;'+
        'font-size:.82rem;cursor:pointer">Switch to subscription</button>';
    box.querySelector("[data-vespr-sub]").addEventListener("click",function(){ convert(this); });
    box.querySelector("[data-vespr-freq]").addEventListener("click",function(e){
      var b=e.target.closest("[data-vespr-w]"); if(!b) return;
      chosen=parseInt(b.getAttribute("data-vespr-w"),10);
      var host=box.parentNode; if(!host) return;
      host.replaceChild(build(item),box);
    });
    return box;
  }

  function apply(cart){
    var host=anchor();
    var eligible = cart && cart.item_count===1 && cart.items && cart.items[0] &&
                   cart.items[0].quantity===1 && !cart.items[0].selling_plan_allocation;
    var cur=existing();
    if(!eligible || !host){ if(cur&&cur.parentNode) cur.parentNode.removeChild(cur); return; }
    if(cur && cur.parentNode===host.parentNode) return;   /* deja en place */
    if(cur&&cur.parentNode) cur.parentNode.removeChild(cur);
    if(observer) observer.disconnect();
    try{ host.parentNode.insertBefore(build(cart.items[0]), host); }catch(_){ }
    watch();
  }

  function refresh(){
    try{
      fetch("/cart.js",{headers:{Accept:"application/json"}})
        .then(function(r){ return r.ok?r.json():null; })
        .then(function(c){ try{ apply(c); }catch(_){ } })
        .catch(function(){ });
    }catch(_){ }
  }

  function schedule(){ clearTimeout(timer); timer=setTimeout(refresh,180); }

  function watch(){
    var root=document.querySelector("cart-drawer");
    if(!root||!window.MutationObserver) return;
    if(!observer) observer=new MutationObserver(schedule);
    observer.observe(root,{childList:true,subtree:true});
  }

  function start(){ watch(); refresh(); }
  if(document.readyState!=="loading") start();
  else document.addEventListener("DOMContentLoaded",start);
  document.addEventListener("cart:updated",schedule);   /* emis par le pont VESPR */
  document.addEventListener("cart:open",schedule);
})();
